const NON_TEXT_INPUT_TYPES = new Set(['button', 'checkbox', 'radio', 'range', 'submit', 'reset', 'file', 'color']);

/** Whether Enter typed into this element means something to the element itself. */
export const isWorkspaceAgentTextEntry = (element: HTMLElement): boolean => {
  if (element.isContentEditable || element instanceof HTMLTextAreaElement) {
    return true;
  }

  return element instanceof HTMLInputElement && !NON_TEXT_INPUT_TYPES.has(element.type);
};
